import UnitesController from './unites.controller';

export default {
    template: require('./unites.tpl.html'),
    controller: UnitesController
};
